// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================================
   DESIGN TOKENS — Pyate Blue Brand
====================================== */
:root {
  --brand:          #1565C0;
  --brand-mid:      #1976D2;
  --brand-light:    #42A5F5;
  --brand-soft:     #E8F1FB;
  --brand-glow:     rgba(21, 101, 192, 0.15);
  --brand-glow-md:  rgba(21, 101, 192, 0.28);
  --surface:        #ffffff;
  --surface-2:      #F5F7FA;
  --surface-3:      #EBF1FB;
  --page-bg:        #F0F2F5;
  --border:         #DCE8F8;
  --border-strong:  #BBCFF5;
  --text-primary:   #0C1A2E;
  --text-secondary: #334D6E;
  --text-muted:     #7090B0;
  --font:           'Plus Jakarta Sans', sans-serif;
  --ease:           cubic-bezier(0.16, 1, 0.3, 1);
  --radius-sm:      8px;
  --radius-md:      14px;
  --radius-lg:      20px;
  --shadow-sm:      0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(21,101,192,0.06);
  --shadow-md:      0 4px 16px rgba(0,0,0,0.08), 0 12px 32px rgba(21,101,192,0.09);
  --shadow-lg:      0 8px 30px rgba(0,0,0,0.10), 0 24px 56px rgba(21,101,192,0.12);
  --shadow-focus:   0 0 0 3px rgba(21,101,192,0.18);
}

* { box-sizing: border-box; }

body {
  font-family: var(--font);
  margin: 0;
  padding: 0;
  background-color: var(--page-bg);
}

/* ======================================
   MAIN PROFILE CONTAINER
====================================== */
.profile_container-editstore {
  font-family: var(--font);
  max-width: 1500px;
  margin: 50px auto;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-lg);
  overflow: hidden;
  background-color: var(--surface);
  box-shadow: var(--shadow-md);
}

/* ======================================
   BANNER — reduced from 350px to 200px
   Gradient fallback when no image set
====================================== */
.profile-banner-editstore {
  width: 100%;
  height: 280px;
  background-color: #C8D8ED;
  background-image: linear-gradient(135deg, #C8D8ED 0%, #B0C4E0 50%, #D4E4F5 100%);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;
}

/* Soft fade at bottom so avatar blends in */
.profile-banner-editstore::after {
  content: '';
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 50px;
  background: linear-gradient(to bottom, transparent, rgba(255,255,255,0.15));
  pointer-events: none;
}

/* Camera button on banner — repositioned to bottom-right */
.profile-banner-editstore button {
  position: absolute !important;
  bottom: 12px !important;
  right: 12px !important;
  top: auto !important;
  background-color: rgba(255, 255, 255, 0.85) !important;
  border: 1.5px solid rgba(255,255,255,0.9) !important;
  cursor: pointer;
  border-radius: 50%;
  padding: 7px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.18s, transform 0.18s;
  z-index: 2;
}

.profile-banner-editstore button:hover {
  background-color: rgba(255,255,255,0.98) !important;
  transform: scale(1.08);
}

/* ======================================
   PROFILE CONTENT AREA
====================================== */
.profile-content-editstore {
  padding: 0 24px 22px;
  text-align: left;
}

/* ======================================
   PROFILE IMAGE
====================================== */
.profile-image-editstore {
  position: relative;
  display: inline-block;
}

/* Override the inline styles in JS */
.profile-image-editstore img {
  width: 120px !important;
  height: 120px !important;
  border-radius: 50% !important;
  border: 4px solid var(--surface) !important;
  margin-top: -60px !important;
  box-shadow: 0 4px 18px rgba(0,0,0,0.14) !important;
  object-fit: cover !important;
  display: block;
}

/* Camera icon on profile photo */
.profile-image-editstore > button {
  position: absolute !important;
  bottom: 4px !important;
  right: -2px !important;
  margin-left: 0 !important;
  background-color: rgba(255,255,255,0.9) !important;
  border: 1.5px solid var(--border-strong) !important;
  border-radius: 50% !important;
  padding: 5px !important;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0,0,0,0.13);
  display: flex !important;
  align-items: center;
  justify-content: center;
  transition: background 0.18s, transform 0.18s;
}

.profile-image-editstore > button:hover {
  background-color: rgba(255,255,255,1) !important;
  transform: scale(1.1);
}

/* The camera icon image inside the button */
.profile-image-editstore > button img {
  width: 16px !important;
  height: 16px !important;
  margin-top: 0 !important;
  margin-left: 0 !important;
  border-radius: 0 !important;
  border: none !important;
  box-shadow: none !important;
}

/* ======================================
   NAME + DESCRIPTION — main fix
====================================== */
.profile-details-editstore {
  margin-top: 12px;
  margin-bottom: 14px;
}

.profile-name-editstore {
  font-family: var(--font);
  font-size: 21px;
  font-weight: 800;
  color: var(--text-primary);
  margin: 0 0 4px;
  letter-spacing: -0.4px;
  line-height: 1.2;
}

.profile-info-editstore {
  font-family: var(--font);
  font-size: 13.5px;
  font-weight: 500;
  color: var(--text-muted);
  margin: 0;
  line-height: 1.55;
}

.profile-tagline-editstore {
  font-family: var(--font);
  font-size: 13px;
  font-weight: 500;
  color: var(--text-muted);
  margin: 3px 0 0;
  line-height: 1.5;
}

/* ======================================
   FOLLOW BUTTON
====================================== */
.actions-editstore {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 4px;
}

.follow-btn-editstore {
  padding: 8px 22px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.1px;
  box-shadow: 0 2px 10px var(--brand-glow);
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);
}

.follow-btn-editstore:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 18px var(--brand-glow-md);
}

.visit-btn-editstore {
  padding: 8px 22px;
  background: var(--surface);
  border: 1.5px solid var(--brand);
  color: var(--brand);
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  transition: all 0.18s var(--ease);
}

.visit-btn-editstore:hover {
  background: var(--brand-soft);
}

/* ======================================
   NAVIGATION TABS
====================================== */
.navigation-tabs-editstore {
  display: flex;
  background-color: var(--surface);
  border-top: 1px solid var(--border);
  border-bottom: 1px solid var(--border);
}

.navigation-tabs-editstore button,
.navigation-tabs-editstore a {
  padding: 13px 20px;
  flex: 1 1;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 600;
  color: var(--text-muted);
  text-decoration: none;
  text-align: center;
  border-bottom: 2.5px solid transparent;
  transition: color 0.18s, border-color 0.18s, background 0.18s;
}

.navigation-tabs-editstore button.active-tab,
.navigation-tabs-editstore .active-tab {
  border-bottom: 2.5px solid var(--brand);
  color: var(--brand);
  font-weight: 700;
  background-color: transparent;
}

.navigation-tabs-editstore button:hover {
  color: var(--brand);
  background-color: var(--brand-soft);
}

.navigation-tabs-editstore .menu {
  display: none;
  position: absolute;
  top: 0.75rem;
  right: 0.5rem;
  flex-direction: column;
  justify-content: space-between;
  width: 2.25rem;
  height: 2rem;
}

.navigation-tabs-editstore .menu span {
  height: 0.4rem;
  width: 100%;
  background-color: #fff;
  border-radius: 0.2rem;
  cursor: pointer;
}

/* ======================================
   APP CONTAINER
====================================== */
.app-container-editstore { width: 80%; margin: 0 auto; }
.banner-editstore { position: relative; }
.banner-image-editstore { width: 100%; height: auto; }

.profile-header-editstore {
  display: flex;
  align-items: center;
  background-color: var(--surface);
  padding: 16px 24px 20px;
  border-bottom: 1px solid var(--border);
}

.logo-section-editstore { flex: 0 0 auto; }
.profile-logo-editstore { width: 80px; height: 80px; border-radius: 50%; }

/* ======================================
   MODALS
====================================== */
.modal {
  display: block;
  position: fixed;
  z-index: 10;
  left: 0; top: 0;
  width: 100%; height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0.42);
}

.modal-content {
  background-color: var(--surface);
  margin: 20% auto;
  padding: 24px;
  border: 1px solid var(--border-strong);
  border-radius: var(--radius-md);
  width: 300px;
  max-width: 90%;
  box-shadow: var(--shadow-md);
}

.close {
  position: absolute;
  top: 15px;
  right: 15px;
  color: var(--text-muted);
  float: right;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.18s;
  line-height: 1;
}

.close:hover { color: var(--text-primary); }

.modal-img {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(10, 20, 40, 0.5);
  backdrop-filter: blur(8px);
  z-index: 1000;
  overflow-y: auto;
}

.modal-content-img {
  background-color: var(--surface);
  border-radius: var(--radius-lg);
  padding: 28px;
  width: 90%;
  max-width: 420px;
  box-shadow: var(--shadow-lg);
  position: relative;
  margin: 20px;
  border: 1px solid var(--border-strong);
}

.modal-content-img h2 {
  font-family: var(--font);
  font-size: 17px;
  font-weight: 800;
  color: var(--brand);
  margin: 0 0 20px;
  text-align: center;
  letter-spacing: -0.2px;
}

.modal-content-img input[type="file"] {
  width: 100%;
  padding: 12px;
  margin: 10px 0;
  border: 1.5px solid var(--border-strong);
  border-radius: var(--radius-sm);
  background-color: var(--surface-2);
  font-family: var(--font);
  font-size: 13px;
  color: var(--text-secondary);
}

.modal-content-img button {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);
  color: white;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  font-family: var(--font);
  font-size: 14px;
  font-weight: 700;
  margin-top: 15px;
  box-shadow: 0 2px 10px var(--brand-glow);
  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);
}

.modal-content-img button:hover {
  transform: translateY(-1px);
  box-shadow: 0 5px 18px var(--brand-glow-md);
}

/* ======================================
   RESPONSIVE
====================================== */
@media (max-width: 992px) {
  .profile_container-editstore { width: 90%; margin-top: 80px; }
  .profile-banner-editstore { height: 230px; }
  .profile-image-editstore img { width: 100px !important; height: 100px !important; margin-top: -50px !important; }
  .app-container-editstore { width: 95%; }
  .profile-name-editstore { font-size: 19px; }
  .profile-tagline-editstore, .profile-info-editstore { font-size: 12.5px; }
  .follow-btn-editstore, .visit-btn-editstore { padding: 7px 18px; }
  .navigation-tabs-editstore button { font-size: 14px; padding: 11px; }
}

@media (max-width: 768px) {
  .profile_container-editstore { width: 95%; margin-top: 80px; }
  .profile-banner-editstore { height: 200px; }
  .profile-content-editstore { padding: 0 16px 16px; }
  .profile-image-editstore img { width: 88px !important; height: 88px !important; margin-top: -44px !important; }
  .profile-name-editstore { font-size: 17px; }
  .profile-tagline-editstore, .profile-info-editstore { font-size: 12px; }
  .app-container-editstore { width: 100%; }
  .profile-header-editstore { flex-direction: column; align-items: flex-start; }
  .logo-section-editstore { margin-bottom: 10px; }
  .navigation-tabs-editstore { flex-direction: row; overflow-x: auto; white-space: nowrap; }
  .navigation-tabs-editstore button { font-size: 13px; padding: 10px; }
  .menu { display: flex; }
}

@media (max-width: 480px) {
  .profile-banner-editstore { height: 160px; }
  .profile-image-editstore img { width: 76px !important; height: 76px !important; margin-top: -38px !important; }
  .profile-name-editstore { font-size: 15px; }
  .profile-tagline-editstore, .profile-info-editstore { font-size: 11px; }
  .navigation-tabs-editstore button { font-size: 12px; padding: 8px; }
  .modal-content { margin: 40% auto; }
  .modal-content-img { padding: 20px 15px; width: 95%; }
  .modal-content-img h2 { font-size: 1.1rem; }
  .close { top: 10px; right: 10px; font-size: 20px; }
}`, "",{"version":3,"sources":["webpack://./src/components/EditStore.css"],"names":[],"mappings":"AAEA;;wCAEwC;AACxC;EACE,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,0CAA0C;EAC1C,0CAA0C;EAC1C,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,yBAAyB;EACzB,iDAAiD;EACjD,+CAA+C;EAC/C,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,8EAA8E;EAC9E,gFAAgF;EAChF,gFAAgF;EAChF,iDAAiD;AACnD;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B;EACE,wBAAwB;EACxB,SAAS;EACT,UAAU;EACV,gCAAgC;AAClC;;AAEA;;wCAEwC;AACxC;EACE,wBAAwB;EACxB,iBAAiB;EACjB,iBAAiB;EACjB,sCAAsC;EACtC,+BAA+B;EAC/B,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;;;wCAGwC;AACxC;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,gFAAgF;EAChF,sBAAsB;EACtB,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAE,OAAO,EAAE,QAAQ;EAC5B,YAAY;EACZ,2EAA2E;EAC3E,oBAAoB;AACtB;;AAEA,2DAA2D;AAC3D;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,sDAAsD;EACtD,oDAAoD;EACpD,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA;;wCAEwC;AACxC;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;;wCAEwC;AACxC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,qCAAqC;AACrC;EACE,uBAAuB;EACvB,wBAAwB;EACxB,6BAA6B;EAC7B,2CAA2C;EAC3C,4BAA4B;EAC5B,kDAAkD;EAClD,4BAA4B;EAC5B,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,sBAAsB;EACtB,yBAAyB;EACzB,kDAAkD;EAClD,mDAAmD;EACnD,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,sCAAsC;EACtC,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,gDAAgD;EAChD,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;;wCAEwC;AACxC;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;EACxC,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;wCAEwC;AACxC;EACE,aAAa;EACb,gCAAgC;EAChC,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;;EAEE,kBAAkB;EAClB,SAAO;EACP,YAAY;EACZ,6BAA6B;EAC7B,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,sCAAsC;EACtC,6DAA6D;AAC/D;;AAEA;;EAEE,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;wCAEwC;AACxC,2BAA2B,UAAU,EAAE,cAAc,EAAE;AACvD,oBAAoB,kBAAkB,EAAE;AACxC,0BAA0B,WAAW,EAAE,YAAY,EAAE;;AAErD;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA,0BAA0B,cAAc,EAAE;AAC1C,0BAA0B,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE;;AAEzE;;wCAEwC;AACxC;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,OAAO,EAAE,MAAM;EACf,WAAW,EAAE,YAAY;EACzB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,aAAa;EACb,sCAAsC;EACtC,+BAA+B;EAC/B,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA,eAAe,0BAA0B,EAAE;;AAE3C;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;EACvC,0BAA0B;EAC1B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,aAAa;EACb,UAAU;EACV,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,cAAc;EACd,wCAAwC;EACxC,+BAA+B;EAC/B,kCAAkC;EAClC,wBAAwB;EACxB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2EAA2E;EAC3E,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wCAAwC;EACxC,mEAAmE;AACrE;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;;wCAEwC;AACxC;EACE,+BAA+B,UAAU,EAAE,gBAAgB,EAAE;EAC7D,4BAA4B,aAAa,EAAE;EAC3C,+BAA+B,uBAAuB,EAAE,wBAAwB,EAAE,4BAA4B,EAAE;EAChH,2BAA2B,UAAU,EAAE;EACvC,0BAA0B,eAAe,EAAE;EAC3C,sDAAsD,iBAAiB,EAAE;EACzE,8CAA8C,iBAAiB,EAAE;EACjE,oCAAoC,eAAe,EAAE,aAAa,EAAE;AACtE;;AAEA;EACE,+BAA+B,UAAU,EAAE,gBAAgB,EAAE;EAC7D,4BAA4B,aAAa,EAAE;EAC3C,6BAA6B,oBAAoB,EAAE;EACnD,+BAA+B,sBAAsB,EAAE,uBAAuB,EAAE,4BAA4B,EAAE;EAC9G,0BAA0B,eAAe,EAAE;EAC3C,sDAAsD,eAAe,EAAE;EACvE,2BAA2B,WAAW,EAAE;EACxC,4BAA4B,sBAAsB,EAAE,uBAAuB,EAAE;EAC7E,0BAA0B,mBAAmB,EAAE;EAC/C,6BAA6B,mBAAmB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;EACzF,oCAAoC,eAAe,EAAE,aAAa,EAAE;EACpE,QAAQ,aAAa,EAAE;AACzB;;AAEA;EACE,4BAA4B,aAAa,EAAE;EAC3C,+BAA+B,sBAAsB,EAAE,uBAAuB,EAAE,4BAA4B,EAAE;EAC9G,0BAA0B,eAAe,EAAE;EAC3C,sDAAsD,eAAe,EAAE;EACvE,oCAAoC,eAAe,EAAE,YAAY,EAAE;EACnE,iBAAiB,gBAAgB,EAAE;EACnC,qBAAqB,kBAAkB,EAAE,UAAU,EAAE;EACrD,wBAAwB,iBAAiB,EAAE;EAC3C,SAAS,SAAS,EAAE,WAAW,EAAE,eAAe,EAAE;AACpD","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');\n\n/* ======================================\n   DESIGN TOKENS — Pyate Blue Brand\n====================================== */\n:root {\n  --brand:          #1565C0;\n  --brand-mid:      #1976D2;\n  --brand-light:    #42A5F5;\n  --brand-soft:     #E8F1FB;\n  --brand-glow:     rgba(21, 101, 192, 0.15);\n  --brand-glow-md:  rgba(21, 101, 192, 0.28);\n  --surface:        #ffffff;\n  --surface-2:      #F5F7FA;\n  --surface-3:      #EBF1FB;\n  --page-bg:        #F0F2F5;\n  --border:         #DCE8F8;\n  --border-strong:  #BBCFF5;\n  --text-primary:   #0C1A2E;\n  --text-secondary: #334D6E;\n  --text-muted:     #7090B0;\n  --font:           'Plus Jakarta Sans', sans-serif;\n  --ease:           cubic-bezier(0.16, 1, 0.3, 1);\n  --radius-sm:      8px;\n  --radius-md:      14px;\n  --radius-lg:      20px;\n  --shadow-sm:      0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(21,101,192,0.06);\n  --shadow-md:      0 4px 16px rgba(0,0,0,0.08), 0 12px 32px rgba(21,101,192,0.09);\n  --shadow-lg:      0 8px 30px rgba(0,0,0,0.10), 0 24px 56px rgba(21,101,192,0.12);\n  --shadow-focus:   0 0 0 3px rgba(21,101,192,0.18);\n}\n\n* { box-sizing: border-box; }\n\nbody {\n  font-family: var(--font);\n  margin: 0;\n  padding: 0;\n  background-color: var(--page-bg);\n}\n\n/* ======================================\n   MAIN PROFILE CONTAINER\n====================================== */\n.profile_container-editstore {\n  font-family: var(--font);\n  max-width: 1500px;\n  margin: 50px auto;\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-lg);\n  overflow: hidden;\n  background-color: var(--surface);\n  box-shadow: var(--shadow-md);\n}\n\n/* ======================================\n   BANNER — reduced from 350px to 200px\n   Gradient fallback when no image set\n====================================== */\n.profile-banner-editstore {\n  width: 100%;\n  height: 280px;\n  background-color: #C8D8ED;\n  background-image: linear-gradient(135deg, #C8D8ED 0%, #B0C4E0 50%, #D4E4F5 100%);\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center;\n  position: relative;\n}\n\n/* Soft fade at bottom so avatar blends in */\n.profile-banner-editstore::after {\n  content: '';\n  position: absolute;\n  bottom: 0; left: 0; right: 0;\n  height: 50px;\n  background: linear-gradient(to bottom, transparent, rgba(255,255,255,0.15));\n  pointer-events: none;\n}\n\n/* Camera button on banner — repositioned to bottom-right */\n.profile-banner-editstore button {\n  position: absolute !important;\n  bottom: 12px !important;\n  right: 12px !important;\n  top: auto !important;\n  background-color: rgba(255, 255, 255, 0.85) !important;\n  border: 1.5px solid rgba(255,255,255,0.9) !important;\n  cursor: pointer;\n  border-radius: 50%;\n  padding: 7px;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.15);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.18s, transform 0.18s;\n  z-index: 2;\n}\n\n.profile-banner-editstore button:hover {\n  background-color: rgba(255,255,255,0.98) !important;\n  transform: scale(1.08);\n}\n\n/* ======================================\n   PROFILE CONTENT AREA\n====================================== */\n.profile-content-editstore {\n  padding: 0 24px 22px;\n  text-align: left;\n}\n\n/* ======================================\n   PROFILE IMAGE\n====================================== */\n.profile-image-editstore {\n  position: relative;\n  display: inline-block;\n}\n\n/* Override the inline styles in JS */\n.profile-image-editstore img {\n  width: 120px !important;\n  height: 120px !important;\n  border-radius: 50% !important;\n  border: 4px solid var(--surface) !important;\n  margin-top: -60px !important;\n  box-shadow: 0 4px 18px rgba(0,0,0,0.14) !important;\n  object-fit: cover !important;\n  display: block;\n}\n\n/* Camera icon on profile photo */\n.profile-image-editstore > button {\n  position: absolute !important;\n  bottom: 4px !important;\n  right: -2px !important;\n  margin-left: 0 !important;\n  background-color: rgba(255,255,255,0.9) !important;\n  border: 1.5px solid var(--border-strong) !important;\n  border-radius: 50% !important;\n  padding: 5px !important;\n  cursor: pointer;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.13);\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.18s, transform 0.18s;\n}\n\n.profile-image-editstore > button:hover {\n  background-color: rgba(255,255,255,1) !important;\n  transform: scale(1.1);\n}\n\n/* The camera icon image inside the button */\n.profile-image-editstore > button img {\n  width: 16px !important;\n  height: 16px !important;\n  margin-top: 0 !important;\n  margin-left: 0 !important;\n  border-radius: 0 !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n/* ======================================\n   NAME + DESCRIPTION — main fix\n====================================== */\n.profile-details-editstore {\n  margin-top: 12px;\n  margin-bottom: 14px;\n}\n\n.profile-name-editstore {\n  font-family: var(--font);\n  font-size: 21px;\n  font-weight: 800;\n  color: var(--text-primary);\n  margin: 0 0 4px;\n  letter-spacing: -0.4px;\n  line-height: 1.2;\n}\n\n.profile-info-editstore {\n  font-family: var(--font);\n  font-size: 13.5px;\n  font-weight: 500;\n  color: var(--text-muted);\n  margin: 0;\n  line-height: 1.55;\n}\n\n.profile-tagline-editstore {\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-muted);\n  margin: 3px 0 0;\n  line-height: 1.5;\n}\n\n/* ======================================\n   FOLLOW BUTTON\n====================================== */\n.actions-editstore {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  margin-top: 4px;\n}\n\n.follow-btn-editstore {\n  padding: 8px 22px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: 0.1px;\n  box-shadow: 0 2px 10px var(--brand-glow);\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);\n}\n\n.follow-btn-editstore:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 18px var(--brand-glow-md);\n}\n\n.visit-btn-editstore {\n  padding: 8px 22px;\n  background: var(--surface);\n  border: 1.5px solid var(--brand);\n  color: var(--brand);\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  transition: all 0.18s var(--ease);\n}\n\n.visit-btn-editstore:hover {\n  background: var(--brand-soft);\n}\n\n/* ======================================\n   NAVIGATION TABS\n====================================== */\n.navigation-tabs-editstore {\n  display: flex;\n  background-color: var(--surface);\n  border-top: 1px solid var(--border);\n  border-bottom: 1px solid var(--border);\n}\n\n.navigation-tabs-editstore button,\n.navigation-tabs-editstore a {\n  padding: 13px 20px;\n  flex: 1;\n  border: none;\n  background-color: transparent;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 600;\n  color: var(--text-muted);\n  text-decoration: none;\n  text-align: center;\n  border-bottom: 2.5px solid transparent;\n  transition: color 0.18s, border-color 0.18s, background 0.18s;\n}\n\n.navigation-tabs-editstore button.active-tab,\n.navigation-tabs-editstore .active-tab {\n  border-bottom: 2.5px solid var(--brand);\n  color: var(--brand);\n  font-weight: 700;\n  background-color: transparent;\n}\n\n.navigation-tabs-editstore button:hover {\n  color: var(--brand);\n  background-color: var(--brand-soft);\n}\n\n.navigation-tabs-editstore .menu {\n  display: none;\n  position: absolute;\n  top: 0.75rem;\n  right: 0.5rem;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 2.25rem;\n  height: 2rem;\n}\n\n.navigation-tabs-editstore .menu span {\n  height: 0.4rem;\n  width: 100%;\n  background-color: #fff;\n  border-radius: 0.2rem;\n  cursor: pointer;\n}\n\n/* ======================================\n   APP CONTAINER\n====================================== */\n.app-container-editstore { width: 80%; margin: 0 auto; }\n.banner-editstore { position: relative; }\n.banner-image-editstore { width: 100%; height: auto; }\n\n.profile-header-editstore {\n  display: flex;\n  align-items: center;\n  background-color: var(--surface);\n  padding: 16px 24px 20px;\n  border-bottom: 1px solid var(--border);\n}\n\n.logo-section-editstore { flex: 0 0 auto; }\n.profile-logo-editstore { width: 80px; height: 80px; border-radius: 50%; }\n\n/* ======================================\n   MODALS\n====================================== */\n.modal {\n  display: block;\n  position: fixed;\n  z-index: 10;\n  left: 0; top: 0;\n  width: 100%; height: 100%;\n  overflow: auto;\n  background-color: rgba(0,0,0,0.42);\n}\n\n.modal-content {\n  background-color: var(--surface);\n  margin: 20% auto;\n  padding: 24px;\n  border: 1px solid var(--border-strong);\n  border-radius: var(--radius-md);\n  width: 300px;\n  max-width: 90%;\n  box-shadow: var(--shadow-md);\n}\n\n.close {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  color: var(--text-muted);\n  float: right;\n  font-size: 24px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: color 0.18s;\n  line-height: 1;\n}\n\n.close:hover { color: var(--text-primary); }\n\n.modal-img {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: rgba(10, 20, 40, 0.5);\n  backdrop-filter: blur(8px);\n  z-index: 1000;\n  overflow-y: auto;\n}\n\n.modal-content-img {\n  background-color: var(--surface);\n  border-radius: var(--radius-lg);\n  padding: 28px;\n  width: 90%;\n  max-width: 420px;\n  box-shadow: var(--shadow-lg);\n  position: relative;\n  margin: 20px;\n  border: 1px solid var(--border-strong);\n}\n\n.modal-content-img h2 {\n  font-family: var(--font);\n  font-size: 17px;\n  font-weight: 800;\n  color: var(--brand);\n  margin: 0 0 20px;\n  text-align: center;\n  letter-spacing: -0.2px;\n}\n\n.modal-content-img input[type=\"file\"] {\n  width: 100%;\n  padding: 12px;\n  margin: 10px 0;\n  border: 1.5px solid var(--border-strong);\n  border-radius: var(--radius-sm);\n  background-color: var(--surface-2);\n  font-family: var(--font);\n  font-size: 13px;\n  color: var(--text-secondary);\n}\n\n.modal-content-img button {\n  width: 100%;\n  padding: 12px;\n  background: linear-gradient(135deg, var(--brand) 0%, var(--brand-mid) 100%);\n  color: white;\n  border: none;\n  border-radius: 100px;\n  cursor: pointer;\n  font-family: var(--font);\n  font-size: 14px;\n  font-weight: 700;\n  margin-top: 15px;\n  box-shadow: 0 2px 10px var(--brand-glow);\n  transition: transform 0.2s var(--ease), box-shadow 0.2s var(--ease);\n}\n\n.modal-content-img button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 5px 18px var(--brand-glow-md);\n}\n\n/* ======================================\n   RESPONSIVE\n====================================== */\n@media (max-width: 992px) {\n  .profile_container-editstore { width: 90%; margin-top: 80px; }\n  .profile-banner-editstore { height: 230px; }\n  .profile-image-editstore img { width: 100px !important; height: 100px !important; margin-top: -50px !important; }\n  .app-container-editstore { width: 95%; }\n  .profile-name-editstore { font-size: 19px; }\n  .profile-tagline-editstore, .profile-info-editstore { font-size: 12.5px; }\n  .follow-btn-editstore, .visit-btn-editstore { padding: 7px 18px; }\n  .navigation-tabs-editstore button { font-size: 14px; padding: 11px; }\n}\n\n@media (max-width: 768px) {\n  .profile_container-editstore { width: 95%; margin-top: 80px; }\n  .profile-banner-editstore { height: 200px; }\n  .profile-content-editstore { padding: 0 16px 16px; }\n  .profile-image-editstore img { width: 88px !important; height: 88px !important; margin-top: -44px !important; }\n  .profile-name-editstore { font-size: 17px; }\n  .profile-tagline-editstore, .profile-info-editstore { font-size: 12px; }\n  .app-container-editstore { width: 100%; }\n  .profile-header-editstore { flex-direction: column; align-items: flex-start; }\n  .logo-section-editstore { margin-bottom: 10px; }\n  .navigation-tabs-editstore { flex-direction: row; overflow-x: auto; white-space: nowrap; }\n  .navigation-tabs-editstore button { font-size: 13px; padding: 10px; }\n  .menu { display: flex; }\n}\n\n@media (max-width: 480px) {\n  .profile-banner-editstore { height: 160px; }\n  .profile-image-editstore img { width: 76px !important; height: 76px !important; margin-top: -38px !important; }\n  .profile-name-editstore { font-size: 15px; }\n  .profile-tagline-editstore, .profile-info-editstore { font-size: 11px; }\n  .navigation-tabs-editstore button { font-size: 12px; padding: 8px; }\n  .modal-content { margin: 40% auto; }\n  .modal-content-img { padding: 20px 15px; width: 95%; }\n  .modal-content-img h2 { font-size: 1.1rem; }\n  .close { top: 10px; right: 10px; font-size: 20px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
